/**
 * Determines the separation between the current page, previous pages, and next pages.
 * The total number of page selections displayed to the user is a combination of current selection,
 * sibling count, and boundary count.
 *
 * @param page
 * @param numberOfPages
 * @returns {{boundaryCount: number, siblingCount: number}}
 */
const getBoundarySettings = (page, numberOfPages) => {
  if (!Number.isInteger(page)) {
    throw Error('a valid page value is required.');
  }

  if (!Number.isInteger(numberOfPages)) {
    throw Error('a valid number of pages value is required.');
  }

  const thirdToLastPageNumber = numberOfPages - 2;
  const isThirdPage = page === 3;
  const isOneOfFirst3Pages = page <= 3;
  const isOneOfLast2Pages = page >= thirdToLastPageNumber;
  const isThirdToLastPage = page === thirdToLastPageNumber;

  // default settings
  let siblingCount = 1;
  let boundaryCount = 1;

  // The next two conditions accounts for specific number of selections we want to show
  // the user when the current selection is the first 3 or last pages. Closely related unselected
  // pages will not hide until the page selection is 4 pages away from the beginning or end of the list.
  if (isOneOfFirst3Pages || isOneOfLast2Pages) {
    siblingCount = 0;
  }

  if (isThirdPage || isThirdToLastPage) {
    boundaryCount = 2;
  }

  return { siblingCount, boundaryCount };
};

export default getBoundarySettings;
